import { render } from "./C_Widgets.vue?vue&type=template&id=cdae8ede&scoped=true"
import script from "./C_Widgets.vue?vue&type=script&lang=js"
export * from "./C_Widgets.vue?vue&type=script&lang=js"

import "./C_Widgets.vue?vue&type=style&index=0&id=cdae8ede&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdae8ede"]])

export default __exports__